var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',{staticClass:"my-4 text-center"},[_vm._v(_vm._s(_vm.title))]),_c('ul',{directives:[{name:"smooth-height",rawName:"v-smooth-height"}],staticClass:"wet-prices-examples"},_vm._l((_vm.items),function(text,i){return _c('li',{key:i,domProps:{"innerHTML":_vm._s(text)}})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }